'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var infoPopovers = {
  bindings: {
    content: '@'
  },
  template: '<i class="icon ion-ios-information label--icon" ng-click="$ctrl.openPopover($event)"></i>',
  controller: function controller($scope, $ionicPopover) {
    var _this = this;

    var content = this.content;

    // .fromTemplate() method
    var template = '<ion-popover-view><ion-content class="padding"> {{"' + content + '" | translate }} </ion-content></ion-popover-view>';

    this.popover = $ionicPopover.fromTemplate(template, { scope: $scope });

    this.openPopover = function ($event) {
      _this.popover.show($event);
    };

    this.closePopover = function () {
      _this.popover.hide();
    };
    //Cleanup the popover when we're done with it!
    $scope.$on('$destroy', function () {
      _this.popover.remove();
    });
    // Execute action on hide popover
    $scope.$on('popover.hidden', function () {
      // Execute action
    });
    // Execute action on remove popover
    $scope.$on('popover.removed', function () {
      // Execute action
    });
  }
};

exports.default = infoPopovers;


/** WEBPACK FOOTER **
 ** ./src/app/directives/popovers/infoPopovers.js
 **/